import { render, staticRenderFns } from "./ticketcategory.vue?vue&type=template&id=9df2d734&"
import script from "./ticketcategory.vue?vue&type=script&lang=js&"
export * from "./ticketcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports